export default function valueWithin($container) {
  let type = $container.getAttribute('data-type')
  if (type !== 'select' && type !== 'textarea') {
    type = 'input[type="' + type + '"]'
  }
  const $input = $container.querySelector(type)

  $input.addEventListener('blur', e => {
    if (e.target.value === '') {
      $container.classList.remove('value-within')
    } else {
      $container.classList.add('value-within')
    }
  })

  if ($input.value !== '') {
    $container.classList.add('value-within')
  }
}



// WEBPACK FOOTER //
// ./src/js/ui/value-within.js